import { Box, Grid, IconButton, TextField } from '@mui/material';
import { createCustomerPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { VyIcon } from '@vy/ui-design-system';
import type { NewCustomer, UpdateCustomer } from '@vy/types';
import { isNotNullOrUndefined, withDefault } from '@vy/utils';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import type { CreateCustomerMode } from '../../../create-customer-page-types/CreateCustomerModeType';

export const CreateCustomerAliases: React.FC<CreateCustomerMode> = ({ mode = 'create' }) => {
  const { control, setValue, formState } =
    useFormContext<typeof mode extends 'create' ? NewCustomer : UpdateCustomer>();

  const aliases = useWatch({
    control,
    name: 'aliases',
  });

  const handleRemoveRow = (index: number) => {
    setValue(
      'aliases',
      withDefault(
        aliases?.filter((_, aliasIndex) => aliasIndex !== index),
        [],
      ),
      {
        shouldDirty: true,
      },
    );
  };

  return (
    <Grid container sx={{
      gap: 2
    }}>
      {aliases?.map((_, index) => (
        <div className="flex w-full gap-6" key={index}>
          <div className="w-full">
            <Controller
              name={`aliases.${index}`}
              control={control}
              render={({ field: aliasField }) => (
                <TextField
                  {...getSelectorAttribute(createCustomerPageSelectors.advanced.alias)}
                  label="Alias"
                  placeholder="Text here"
                  {...aliasField}
                  fullWidth
                  error={isNotNullOrUndefined(formState.errors.aliases?.[index])}
                  helperText={formState.errors.aliases?.[index]?.message}
                />
              )}
            />
          </div>
          <Box
            sx={{
              marginTop: 'auto',
              marginBottom: 0.5,
            }}
          >
            <IconButton onClick={() => handleRemoveRow(index)}>
              <VyIcon icon="Truncate" />
            </IconButton>
          </Box>
        </div>
      ))}
    </Grid>
  );
};
